module.exports = __webpack_public_path__ + "static/img/home_lun3.0d7522c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_lun3.jpg
// module id = g8kj
// module chunks = 1